import React, { useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './SplashScreenUI.css'

const SplashScreenUI = (props: UIProperties<SplashScreenUIConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container modal-disable-select">
			<img src="./assets/images/general/backgrounds/splash-screen.jpg" />
			<img style={{
				position: 'absolute',
				top: '70%',
				left: '40%',
				width: '100px',
			}} src="./assets/images/general/icons/spinner.png" />
			<p style={{
				position: 'absolute',
				top: '72%',
				left: '47%',
				color: 'rgb(130,136,248)',
				textShadow: '2px 2px rgba(0,0,0,.7)',
				fontSize: '40px',
				margin: '0',
				fontWeight: 400
			}} className="regular-description-font">Loading...</p>
		</div>
	);

};

export interface SplashScreenUIConfig extends BaseConfig {
}

export default SplashScreenUI;